/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MetierLocaliteDto
 */
export interface MetierLocaliteDto {
    /**
     * 
     * @type {number}
     * @memberof MetierLocaliteDto
     */
    idcodePostal?: number;
    /**
     * 
     * @type {string}
     * @memberof MetierLocaliteDto
     */
    codePostal?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MetierLocaliteDto
     */
    localite?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MetierLocaliteDto
     */
    selected?: boolean;
}

/**
 * Check if a given object implements the MetierLocaliteDto interface.
 */
export function instanceOfMetierLocaliteDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MetierLocaliteDtoFromJSON(json: any): MetierLocaliteDto {
    return MetierLocaliteDtoFromJSONTyped(json, false);
}

export function MetierLocaliteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetierLocaliteDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idcodePostal': !exists(json, 'idcodePostal') ? undefined : json['idcodePostal'],
        'codePostal': !exists(json, 'codePostal') ? undefined : json['codePostal'],
        'localite': !exists(json, 'localite') ? undefined : json['localite'],
        'selected': !exists(json, 'selected') ? undefined : json['selected'],
    };
}

export function MetierLocaliteDtoToJSON(value?: MetierLocaliteDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idcodePostal': value.idcodePostal,
        'codePostal': value.codePostal,
        'localite': value.localite,
        'selected': value.selected,
    };
}

